import { render, staticRenderFns } from "./LoadoutsView.vue?vue&type=template&id=66d166eb&scoped=true&"
import script from "./LoadoutsView.vue?vue&type=script&lang=ts&"
export * from "./LoadoutsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d166eb",
  null
  
)

export default component.exports